<script>

import ListingsChartHover from './ListingsChartHover';

export default {
  components: { ListingsChartHover },
  data() {
    return {
      loading: true,
      cur_month: '',
      listings: [],
      filters: {
        selects: [
          'id',
          'StandardStatus',
          'Address',
          'City',
          'StateOrProvince',
          'PostalCode',
          'ListingContractDate',
          'PendingTimestamp',
          'CloseDate',
          'ExpirationDate',
          'CancellationDate',
          'created_at',
          'packages_total',
          'estimated_total',
          'mls_title',
          'active_package',
          'active_services',
          'ListingId',
          'mls_updated_at',
        ],
        whereins: {
          website: [],
        },
        withs: { carts: { total: 0, wheres: { status: 3, }, orderbys: { paid_date: 'asc', }, }, },
        notins: { StandardStatus: ['Trash'], },
      },
    }
  },
  computed: {
    month_results: function() {
      var results = {
        start: this.moment(this.cur_month).startOf('month').startOf('day'),
        end: this.moment(this.cur_month).endOf('month').endOf('day'),
        p_1: [],
        p_2: [],
        services: [],
        weeks: [],
        totals: {
          start: this.moment(this.cur_month).startOf('year').startOf('day'),
          end: this.moment(this.cur_month).endOf('year').endOf('day'),
          p_1: [],
          p_2: [],
          services: [],
        },
      },
      // month_weeks = Math.round(this.moment.duration(results.end - results.start).asWeeks() + 1),
      date = this.moment(this.cur_month).startOf('month').startOf('day'),
      i = 0,
      max = 6;

      while(max--){
        if(i > 1 && !this.moment(date).startOf('week').isSame(this.moment(results.start), 'month')) { break; }
        results.weeks[i] = {
          start: this.moment(date).startOf('week').startOf('day'),
          end: this.moment(date).endOf('week').endOf('day'),
          p_1: [],
          p_2: [],
          services: [],
        };
        date.add(1, 'week');
        i++;
      }

      for(var i in this.listings){
        if(this.listings[i].carts && this.listings[i].carts.length) {
          for(var j in this.listings[i].carts){
            this.setData(this.listings[i], this.listings[i].carts[j], results);
            this.setData(this.listings[i], this.listings[i].carts[j], results.totals);
            for(var k in results.weeks){
              this.setData(this.listings[i], this.listings[i].carts[j], results.weeks[k]);
            }
          }
        } else {

        }
      }
      // console.log(results);

      return results;
    },
  },
  created() {
    this.filters.whereins.website = [this.website_id];
    this.cur_month = this.moment();
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/listings/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        for(var i in res.data.data) {
          if(!res.data.data[i].active_services){ res.data.data[i].active_services = []; }
          if(res.data.data[i].active_services && typeof res.data.data[i].active_services === 'object'){ res.data.data[i].active_services = Object.values(res.data.data[i].active_services); }
        }
        this.listings = res.data.data;
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    setData(listing, cart, results) {
      if(this.moment(cart.paid_date).isBetween(results.start, results.end, null, '[]')) {
        if(cart.package && cart.package.id && results['p_'+cart.package.id]) {
          results['p_'+cart.package.id].push({
            id: listing.id,
            StandardStatus: listing.StandardStatus,
            created_at: listing.created_at,
            ListingContractDate: listing.ListingContractDate,
            PendingTimestamp: listing.PendingTimestamp,
            CloseDate: listing.CloseDate,
            ExpirationDate: listing.ExpirationDate,
            CancellationDate: listing.CancellationDate,
            Address: listing.Address,
            City: listing.City,
            StateOrProvince: listing.StateOrProvince,
            PostalCode: listing.PostalCode,
            mls_updated_at: listing.mls_updated_at,
            mls_title: listing.mls_title,
            active_package: cart.package,
            active_services: cart.services,
            estimated_total: cart.total,
            paid_date: cart.paid_date,
            cart_created_at: cart.created_at,
          });
        }
        if(cart.services && cart.services.length) {
          results.services.push({
            id: listing.id,
            StandardStatus: listing.StandardStatus,
            created_at: listing.created_at,
            ListingContractDate: listing.ListingContractDate,
            PendingTimestamp: listing.PendingTimestamp,
            CloseDate: listing.CloseDate,
            ExpirationDate: listing.ExpirationDate,
            CancellationDate: listing.CancellationDate,
            Address: listing.Address,
            City: listing.City,
            StateOrProvince: listing.StateOrProvince,
            PostalCode: listing.PostalCode,
            mls_updated_at: listing.mls_updated_at,
            mls_title: listing.mls_title,
            active_package: cart.package,
            active_services: cart.services,
            estimated_total: cart.total,
            paid_date: cart.paid_date,
            cart_created_at: cart.created_at,
          });
        }
      }
    },
  }
}
</script>

<template>
  <div class="card-box p-0 position-relative" id="print-listings_revenue_chart">
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="p-3">
      <div class="float-right">
        <div class="ml-2">
          <w-field SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="fetchData()" :Disabled="loading"></w-field>
        </div>
        <button type="button" class="btn btn-light ml-2" @click="cur_month = moment()">Today</button>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-light ml-2" @click="cur_month = moment(cur_month).subtract(1, 'month')"><Icon icon="ri:arrow-left-s-line" /></button>
          <button type="button" class="btn btn-light " @click="cur_month = moment(cur_month).add(1, 'month')"><Icon icon="ri:arrow-right-s-line" /></button>
        </div>
        <button type="button" class="btn btn-light ml-2 print_target" target="print-listings_revenue_chart" v-tippy title="Print"><Icon icon="ri:printer-line" /></button>
      </div>
      <h4 class="header-title"><Icon icon="ri:home-2-line" /> Revenue Report</h4>
      <p class="m-0 small">Orders placed this year : <strong>{{(
        month_results.totals.p_1.length +
        month_results.totals.p_2.length +
        month_results.totals.services.length
        )}}</strong>
      </p>
      <p class="m-0 small">Revenue this year : <strong>{{formatPrice(
          month_results.totals.p_1.reduce((a, b) => a + (b.active_package && b.active_package.price ? parseFloat(b.active_package.price) : 0), 0) +
          month_results.totals.p_2.reduce((a, b) => a + (b.active_package && b.active_package.price ? parseFloat(b.active_package.price) : 0), 0) +
          month_results.totals.services.reduce((a, b) => a + (b.active_services ? b.active_services.reduce((c, d) => c + (d.price ? parseFloat(d.price) : 0), 0) : 0), 0)
        )}}</strong>
      </p>
      <div class="clearfix"></div>
      <div class="alert alert-danger small mt-2 mb-0 py-1">This widget is broken with the new update. This alert will be removed once the widget has been updated to function with the 5.0 update.</div>
    </div>
    <table class="table table-sm table-hover m-0 small">
      <thead>
        <tr>
          <th class="border-0 bg-light font-weight-bold">{{moment(cur_month).format('MMMM')}} {{moment(cur_month).format('YYYY')}}</th>
          <th class="border-0 text-center font-weight-bold" v-tippy title="">Gold</th>
          <th class="border-0 text-center font-weight-bold" v-tippy title="">Platinum</th>
          <th class="border-0 text-center font-weight-bold" v-tippy title="">Add Ons</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in month_results.weeks" :key="index">
          <th class="align-middle font-weight-bold py-1">Week {{index+1}} <div class="small font-weight-normal">{{moment(item.start).format('MM-DD-YYYY')}} - {{moment(item.end).format('MM-DD-YYYY')}}</div></th>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">
              <div class="text-success font-weight-bold">{{formatPrice(item.p_1.reduce((a, b) => a + (b.active_package && b.active_package.price ? parseFloat(b.active_package.price) : 0), 0))}}</div>
              <div class="small">{{item.p_1.length}}</div>
            </div>
            <div v-if="item.p_1.length" class="dropdown-menu dropdown-menu-right fade _box-shadow-0-1-10-b-2 mt-0 _w-500 p-2">
              <ListingsChartHover :items="item.p_1"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">
              <div class="text-success font-weight-bold">{{formatPrice(item.p_2.reduce((a, b) => a + (b.active_package && b.active_package.price ? parseFloat(b.active_package.price) : 0), 0))}}</div>
              <div class="small">{{item.p_2.length}}</div>
            </div>
            <div v-if="item.p_2.length" class="dropdown-menu dropdown-menu-right fade _box-shadow-0-1-10-b-2 mt-0 _w-500 p-2">
              <ListingsChartHover :items="item.p_2"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">
              <div class="text-success font-weight-bold">{{formatPrice(item.services.reduce((a, b) => a + (b.active_services ? b.active_services.reduce((c, d) => c + (d.price ? parseFloat(d.price) : 0), 0) : 0), 0))}}</div>
              <div class="small">{{item.services.length}}</div>
            </div>
            <div v-if="item.services.length" class="dropdown-menu dropdown-menu-right fade _box-shadow-0-1-10-b-2 mt-0 _w-500 p-2">
              <ListingsChartHover :items="item.services"></ListingsChartHover>
            </div>
          </td>
        </tr>
        <tr>
          <th class="align-middle bg-primary text-white py-1">Month <div class="small">{{moment(month_results.start).format('MM-DD-YYYY')}} - {{moment(month_results.end).format('MM-DD-YYYY')}}</div></th>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">
              <div class="text-success font-weight-bold">{{formatPrice(month_results.p_1.reduce((a, b) => a + (b.active_package && b.active_package.price ? parseFloat(b.active_package.price) : 0), 0))}}</div>
              <div class="small">{{month_results.p_1.length}}</div>
            </div>
            <div v-if="month_results.p_1.length" class="dropdown-menu dropdown-menu-right fade _box-shadow-0-1-10-b-2 mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.p_1"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">
              <div class="text-success font-weight-bold">{{formatPrice(month_results.p_2.reduce((a, b) => a + (b.active_package && b.active_package.price ? parseFloat(b.active_package.price) : 0), 0))}}</div>
              <div class="small">{{month_results.p_2.length}}</div>
            </div>
            <div v-if="month_results.p_2.length" class="dropdown-menu dropdown-menu-right fade _box-shadow-0-1-10-b-2 mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.p_2"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">
              <div class="text-success font-weight-bold">{{formatPrice(month_results.services.reduce((a, b) => a + (b.active_services ? b.active_services.reduce((c, d) => c + (d.price ? parseFloat(d.price) : 0), 0) : 0), 0))}}</div>
              <div class="small">{{month_results.services.length}}</div>
            </div>
            <div v-if="month_results.services.length" class="dropdown-menu dropdown-menu-right fade _box-shadow-0-1-10-b-2 mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.services"></ListingsChartHover>
            </div>
          </td>
        </tr>
        <tr>
          <th class="align-middle bg-success text-white py-1">Year <div class="small">{{moment(month_results.totals.start).format('MM-DD-YYYY')}} - {{moment(month_results.totals.end).format('MM-DD-YYYY')}}</div></th>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">
              <div class="text-success font-weight-bold">{{formatPrice(month_results.totals.p_1.reduce((a, b) => a + (b.active_package && b.active_package.price ? parseFloat(b.active_package.price) : 0), 0))}}</div>
              <div class="small">{{month_results.totals.p_1.length}}</div>
            </div>
            <div v-if="month_results.totals.p_1.length" class="dropdown-menu dropdown-menu-right fade _box-shadow-0-1-10-b-2 mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.totals.p_1"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">
              <div class="text-success font-weight-bold">{{formatPrice(month_results.totals.p_2.reduce((a, b) => a + (b.active_package && b.active_package.price ? parseFloat(b.active_package.price) : 0), 0))}}</div>
              <div class="small">{{month_results.totals.p_2.length}}</div>
            </div>
            <div v-if="month_results.totals.p_2.length" class="dropdown-menu dropdown-menu-right fade _box-shadow-0-1-10-b-2 mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.totals.p_2"></ListingsChartHover>
            </div>
          </td>
          <td class="align-middle text-center dropdown hover_open py-1">
            <div class="dropdown-toggle" data-toggle="dropdown">
              <div class="text-success font-weight-bold">{{formatPrice(month_results.totals.services.reduce((a, b) => a + (b.active_services ? b.active_services.reduce((c, d) => c + (d.price ? parseFloat(d.price) : 0), 0) : 0), 0))}}</div>
              <div class="small">{{month_results.totals.services.length}}</div>
            </div>
            <div v-if="month_results.totals.services.length" class="dropdown-menu dropdown-menu-right fade _box-shadow-0-1-10-b-2 mt-0 _w-500 p-2">
              <ListingsChartHover :items="month_results.totals.services"></ListingsChartHover>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>
